import { render, staticRenderFns } from "./OptMobileApp.vue?vue&type=template&id=c1b70b40&"
import script from "./OptMobileApp.vue?vue&type=script&lang=js&"
export * from "./OptMobileApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports